var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.472 8.202L11.636 16.226L3.6 10.2L7.2 5.4L10.365 7.774L13.299 3.739C12.882 3.549 12.452 3.38 12 3.263V1H8V3.263C7.099 3.497 6.256 3.875 5.507 4.386L3.99 2.868L1.868 4.989L3.386 6.507C2.875 7.256 2.497 8.098 2.264 9H0V13H2.264C2.497 13.902 2.875 14.744 3.386 15.493L1.868 17.011L3.99 19.132L5.507 17.615C6.256 18.125 7.099 18.503 8 18.737V21H12V18.737C12.902 18.503 13.744 18.125 14.493 17.615L16.011 19.132L18.132 17.011L16.615 15.493C17.125 14.744 17.504 13.902 17.737 13H20V9H17.737C17.666 8.726 17.57 8.464 17.472 8.202",
    fill: "#014B3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2121 13.4091L6.40015 9.80011L7.60015 8.20011L10.7881 10.5911L18.1911 0.412109L19.8091 1.58811L11.2121 13.4091Z",
    fill: "#014B3E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.b24d5d2d.svg";
export { ForwardRef as ReactComponent };